import React, {useEffect, useRef} from 'react'
import clsx from 'clsx'
import {useLocation} from 'react-router'
import {KTSVG, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'
import {checkIsActive} from './SidebarMenuItem'

type Props = {
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
}

const SidebarMenuItemWithSub: React.FC<Props & WithChildren> = ({
  children,
  title,
  icon,
  fontIcon,
  hasBullet,
}) => {
  const {pathname} = useLocation()
  const isActive = React.Children.toArray(children).some(
    (child) =>
      React.isValidElement<{to?: string}>(child) &&
      !!child.props.to &&
      checkIsActive(pathname, child.props.to)
  )
  const itemRef = useRef<HTMLDivElement>(null)
  const {config} = useLayout()
  const {app} = config

  // MenuComponent opens and closes groups by changing the DOM directly, and closing leaves
  // inline styles on the list. Reopen the current page's group after any navigation that
  // didn't come from the menu, such as the browser's Back button.
  useEffect(() => {
    const sub = itemRef.current?.querySelector<HTMLElement>(':scope > .menu-sub')
    if (isActive && sub) {
      itemRef.current?.classList.add('show')
      sub.style.removeProperty('display')
      sub.style.removeProperty('overflow')
    }
  }, [isActive, pathname])

  return (
    <div
      ref={itemRef}
      className={clsx('menu-item', {'here show': isActive}, 'menu-accordion')}
      data-kt-menu-trigger='click'
    >
      <span className='menu-link'>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <i className={clsx('bi fs-3', fontIcon)}></i>
        )}
        <span className='menu-title'>{title}</span>
        <span className='menu-arrow'></span>
      </span>
      <div className={clsx('menu-sub menu-sub-accordion', {'menu-active-bg': isActive})}>
        {children}
      </div>
    </div>
  )
}

export {SidebarMenuItemWithSub}
